import * as React from 'react'
import { OnboardingComponentProps } from '.'
import { Stack, Spacing } from '@doordash/design-language'

export const StackComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ size, ...props }) => {
    const stackSize =
      typeof size === 'string' && size in Spacing ? Spacing[size] : Spacing.None
    return <Stack size={stackSize} {...props} />
  }
)
